export default __webpack_public_path__ + "static/media/Uncertainty@3x.eef05aeb.png";